const getDialog = (rootState) => rootState.ui.dialogs.activeDialog;

export default getDialog;
